
import { useState, useEffect } from 'react';
import { portfolioData } from '../../../mocks/portfolio';

const navItems = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (href: string) => {
    setMenuOpen(false);
    if (href === '#hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-[#e8d5bc]/40'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12 flex items-center justify-between h-16">
        {/* Logo */}
        <button
          onClick={() => scrollTo('#hero')}
          className="cursor-pointer flex items-center gap-2 group"
        >
          <span
            className={`font-black text-xl tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-[#1a1a1a]' : 'text-[#1a1a1a]'
            }`}
          >
            {portfolioData.hero.name.split(' ')[0]}
          </span>
          <span
            className={`font-serif italic text-xl transition-colors duration-300 ${
              scrolled ? 'text-[#8a6a4a]' : 'text-[#6b4f35]'
            }`}
          >
            {portfolioData.hero.name.split(' ')[1]}
          </span>
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollTo(item.href)}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap relative group ${
                scrolled
                  ? 'text-[#4a4a4a] hover:text-[#3d2b1f]'
                  : 'text-[#3d2b1f] hover:text-[#1a1a1a]'
              }`}
            >
              {item.label}
              <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-[#8a6a4a] transition-all duration-300 group-hover:w-full"></span>
            </button>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:flex items-center">
          <button
            onClick={() => scrollTo('#contact')}
            className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'bg-[#3d2b1f] text-white hover:bg-[#5a3d2b]'
                : 'bg-[#3d2b1f]/90 text-white hover:bg-[#3d2b1f]'
            }`}
          >
            お問い合わせ
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i
            className={`text-[#3d2b1f] text-xl ${
              menuOpen ? 'ri-close-line' : 'ri-menu-3-line'
            }`}
          ></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        } bg-white/98 backdrop-blur-md border-b border-[#e8d5bc]/40`}
      >
        <nav className="container mx-auto px-6 py-4 flex flex-col gap-1">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollTo(item.href)}
              className="text-left text-sm font-medium text-[#4a4a4a] hover:text-[#3d2b1f] py-3 border-b border-[#f0e8de] last:border-0 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('#contact')}
            className="mt-3 bg-[#3d2b1f] text-white px-5 py-2.5 rounded-lg text-sm font-semibold text-center cursor-pointer whitespace-nowrap"
          >
            お問い合わせ
          </button>
        </nav>
      </div>
    </header>
  );
}
